import { gql } from "apollo-boost";

export const CREATE_DONATE_WEBSITE = gql`
mutation CreateDonate($data: DonateWhereInput) {
  createDonate(data: $data) {
    id
  }
}
`;